import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";

interface SportsFilterProps {
  sports: { id: string, name: string }[];
  selectedSportId: string | null;
  onSelectSport: (sportId: string | null) => void;
}

const SportsFilter = ({ sports, selectedSportId, onSelectSport }: SportsFilterProps) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [value, setValue] = useState<string | undefined>(isDesktop ? "sports" : undefined);

  useEffect(() => {
    setValue(isDesktop ? "sports" : undefined);
  }, [isDesktop]);

  return (
    <Accordion 
      type="single" 
      value={value} 
      onValueChange={setValue}
      collapsible
    >
      <AccordionItem value="sports" className="border-none">
        <AccordionTrigger className="hover:no-underline">
          <h3 className="text-xl font-semibold">Sports</h3>
        </AccordionTrigger>
        <AccordionContent>
          <div className="flex flex-wrap gap-2 pt-2">
            {sports.map((sport) => (
              <Button
                key={sport.id}
                variant={selectedSportId === sport.id ? "default" : "outline"}
                onClick={() => onSelectSport(selectedSportId === sport.id ? null : sport.id)}
                className="text-sm"
              >
                {sport.name}
              </Button>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default SportsFilter;
